import { render, staticRenderFns } from "./UtilizationTable.vue?vue&type=template&id=23e2eadc"
import script from "./UtilizationTable.vue?vue&type=script&lang=js"
export * from "./UtilizationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports